/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRipple = createReactComponent("ripple", "IconRipple", [
  ["path", { d: "M3 7c3 -2 6 -2 9 0s6 2 9 0", key: "svg-0" }],
  ["path", { d: "M3 17c3 -2 6 -2 9 0s6 2 9 0", key: "svg-1" }],
  ["path", { d: "M3 12c3 -2 6 -2 9 0s6 2 9 0", key: "svg-2" }]
]);

export { IconRipple as default };
//# sourceMappingURL=IconRipple.js.map
